const data = [
  {
    classIcon: `${process.env.PUBLIC_URL}/truck.png`,
    header: "Suivi GPS en temps réel de vos véhicules",
    text: "Localisez et gérez votre flotte de véhicules (voitures, camions, motos, tracteurs) avec un suivi de carburant précis et des alertes instantanées pour optimiser vos coûts et votre productivité.",
    useIcon: false,
  },
  {
    classIcon: `${process.env.PUBLIC_URL}/maps.png`,
    header: "Surveillance continue de vos actifs",
    text: "Suivez vos équipements et matériels en toute autonomie grâce à nos trackers auto-alimentés avec une batterie longue durée, garantissant une surveillance 24/7 sans interruption.",
    useIcon: false,
  },
  {
    classIcon: `${process.env.PUBLIC_URL}/app-development.png`,
    header: "Plateforme de gestion de flotte complète",
    text: "Optimisez vos opérations avec des rapports détaillés, des alertes en temps réel, l'analyse des trajets et la gestion intelligente de votre flotte pour réduire vos coûts opérationnels.",
    useIcon: false,
  },
];

export default data;
